const getParentOrigin = () => {
    if (typeof window === "undefined" || window.parent === window) return "";

    try {
        const publicBase = new URLSearchParams(window.location.search).get("public_base");
        if (publicBase) return new URL(publicBase).origin;
    } catch (_error) {
        // Fall back to the configured wildcard only when the wrapper URL is absent
        // or malformed. The parent validates the sender origin before accepting it.
    }

    return "*";
};

// Logged-in customer id, kept module-level so every component reports the same
// GA4 User-ID without threading it through React props. Empty until login or
// registration has resolved the customer (see GETCustomers).
let currentUserId = "";

const normalizeUserId = (userId) => (
    userId === null || userId === undefined ? "" : String(userId).trim()
);

/**
 * Bind the real user id (customer id) to analytics.
 *
 * Called once the customer is known, after login or registration. From then on
 * the id is attached to every sendEvent payload; the parent wrapper turns it
 * into the GA4 User-ID. An empty value clears the binding (logout).
 */
export const setUserId = (userId) => {
    currentUserId = normalizeUserId(userId);
};

export const clearUserId = () => {
    currentUserId = "";
};

export const getUserId = () => currentUserId;

/**
 * Send an analytics event from the reservation iframe to its parent wrapper.
 *
 * The parent is responsible for forwarding the event to its own GA4/GTM
 * implementation. Keeping this as a small exported helper lets reservation
 * components call sendEvent("event_name", { key: "value" }) later. The current
 * user id is merged into the parameters when available, so callers never have
 * to pass it explicitly.
 */
export const sendEvent = (name, params = {}) => {
    if (typeof window === "undefined" || window.parent === window) return;

    const eventName = String(name || "").trim();
    if (!eventName) return;

    const parameters = params && typeof params === "object" ? {...params} : {};
    const userId = normalizeUserId(currentUserId);
    if (userId) {
        parameters.user_id = userId;
    }

    window.parent.postMessage({
        type: "kav2go_analytics",
        event: eventName,
        parameters,
    }, getParentOrigin());
};
